export default {
  PRIMARY: "primary",
  INFO: "info",
  DANGER: "danger",
  SUCCESS: "success"
};
